define(['modules/common/controls/control'], (Control) => Control.extend({

    binders: {
        value: {
            bind (view, publish) {
                this.callback = function () {
                    publish(view.get());
                };
                view.on('change', this.callback);
            },
            unbind (view) {
                view.off('change', this.callback);
            },
            routine (view, value) {
                view.set(value);
            }
        },
        toggle (view, value) {
            view.$el.toggle(Boolean(value));
        }
    },

    tagName: 'ul',
    className: 'nav nav-pills nav-pills-compact',

    events: {
        'click li': 'pillChange'
    },

    defaults: _.extend({
        id: 'id',
        text: 'name',
        allowNoSelection: false,
        enabled: true
    }, Control.prototype.defaults),

    initialize () {
        Control.prototype.initialize.apply(this, arguments);

        this.choices = this.options.choices;
        this.selection = null;

        this.multiple = Boolean(this.options.multiple);

        if (this.multiple) {
            this.multipleFallbackValue = this.choices.get(this.options.defaultValue) || null;
            if (this.multipleFallbackValue) {
                this.choices.remove(this.multipleFallbackValue);
                this.choices.unshift(this.multipleFallbackValue);
            }

            this.activePills = [this.choices.first().id];
        }

        this.listenTo(this.choices, 'reset', function () {
            this.render();
            this.set(this.get());
        });
    },

    render () {
        this.$el.empty().append(this.choices.toJSON().map(function (item) {
            const $pill = $('<li>').append(
                $('<a>').attr(this.options.enabled ? {href: '#'} : {}).
                    html(this.formatChoice(item))
            );
            if (this.multiple) {
                $pill.addClass('multiple-pills');
            }
            return $pill;
        }, this));

        return this;
    },

    formatChoice (item) {
        return item[this.options.text];
    },

    get () {
        if (this.multiple) {
            return this.activePills.slice();
        }
        return this.selection ? this.selection.id : null;

    },

    set (value) {
        if (this.multiple) {
            if (!Array.isArray(value)) {
                value = [value];
            }
            if (this.multipleFallbackValue && this.activePills[0] === this.multipleFallbackValue.id &&
                    this.activePills.length === 1) {
                this.activePills = [];
            }
            if (value) {
                value.forEach(function (element) {
                    const selected = this.choices.get(element);
                    if (selected !== undefined) {
                        if (this.multipleFallbackValue && selected === this.multipleFallbackValue) {
                            this.activePills = [this.multipleFallbackValue.id];
                        } else {
                            const valueIndex = this.activePills.indexOf(selected.id);
                            if (valueIndex === -1) {
                                this.activePills.push(selected.id);
                            } else {
                                this.activePills.splice(valueIndex, 1);
                            }
                        }
                    }
                }, this);
            } else {
                this.activePills = this.multipleFallbackValue ? [this.multipleFallbackValue.id] : [];
            }

            if (this.activePills.length === 0 && this.multipleFallbackValue) {
                this.activePills = [this.multipleFallbackValue.id];
            }
        } else {

            this.selection = this.choices.get(value) || (this.options.allowNoSelection ? null
                : this.choices.first());
        }
        this.selectPill();
    },

    pillChange (event) {
        if (!this.options.enabled) {
            return;
        }

        const index = $(event.currentTarget).index();
        const selection = this.choices.at(index);
        if (this.multiple || selection.id !== this.selection.id) {
            this.set(selection.id);
            this.trigger('change');
        }
        return false;
    },

    selectPill () {
        this.$('li').removeClass('active');

        if (this.multiple) {
            this.activePills.forEach(function (element) {
                const choice = this.choices.get(element);
                const index = this.choices.indexOf(choice);

                this.$('li:eq({0})'.format(index)).addClass('active');
            }, this);

        } else {

            const index = this.choices.indexOf(this.selection);

            if (index >= 0) {
                this.$('li:eq({0})'.format(index)).addClass('active');
            }
        }
    }
}));
